import PromiseBatcher from '@/Utility/PromiseBatcher';

export default class CallbackBatcher {
    private static readonly intervalInMs: number = 100;
    private static readonly maxBatchSize: number = 50;
    
    private static callbacks: Function[] = [];
    private static currentTimerHandle: number | null = null;
    private static currentResolver: Function = null;
    
    public static add(callback: Function, promiseBatcher?: PromiseBatcher): void {
        CallbackBatcher.callbacks.push(callback);
        
        if (CallbackBatcher.callbacks.length < CallbackBatcher.maxBatchSize) {
            CallbackBatcher.tryStartTimer(promiseBatcher);
        }
        else {
            this.flush(promiseBatcher);
        }
    }

    private static flush(promiseBatcher?: PromiseBatcher) {
        const resolver = CallbackBatcher.currentResolver;
        
        if (CallbackBatcher.currentTimerHandle != null) 
            window.clearTimeout(CallbackBatcher.currentTimerHandle);
        
        const action = (callback?: Function) => {
            // Die Callbacks müssen außerhalb des timeouts geholt werden, da das Array sofort geleert werden soll.
            const callbacks = CallbackBatcher.getCallbacksAndClear();
            window.setTimeout(() => {
                CallbackBatcher.processBatch(callbacks);
                if (callback)
                    callback();
            });
        };
        
        if (promiseBatcher) {
            const promise = new Promise<void>((resolve) => action(resolve));
            promiseBatcher.add(promise);
        }
        else {
            action();
        }

        if (resolver != null)
            resolver();
    }
    
    private static tryStartTimer(promiseBatcher?: PromiseBatcher): void {
        if (CallbackBatcher.currentTimerHandle !== null)
            return;
        
        const action = (callback?: Function) => {
            CallbackBatcher.currentTimerHandle = window.setTimeout(() => {
                const callbacks = CallbackBatcher.getCallbacksAndClear();
                CallbackBatcher.processBatch(callbacks);
                if (callback)
                    callback();
            }, CallbackBatcher.intervalInMs);
        };
        
        if (promiseBatcher) {
            const promise = new Promise<void>((resolve) => {
                CallbackBatcher.currentResolver = resolve;
                action(() => resolve());
            });

            promiseBatcher.add(promise);
        }
        else {
            CallbackBatcher.currentResolver = null;
            action();
        }
    }

    private static getCallbacksAndClear(): Function[] {
        const callbacks = CallbackBatcher.callbacks;
       
        CallbackBatcher.callbacks = [];
        CallbackBatcher.currentTimerHandle = null;
        CallbackBatcher.currentResolver = null;
        
        return callbacks;
    }
    
    private static processBatch(callbacks: Function[]): void {
        for (let callback of callbacks) {
            callback();
        }
    }
}